import { render, staticRenderFns } from "./FattuttoTransmissions.vue?vue&type=template&id=af606650&scoped=true&"
import script from "./FattuttoTransmissions.vue?vue&type=script&lang=js&"
export * from "./FattuttoTransmissions.vue?vue&type=script&lang=js&"
import style0 from "./FattuttoTransmissions.vue?vue&type=style&index=0&id=af606650&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af606650",
  null
  
)

export default component.exports